export default __webpack_public_path__ + "static/media/icon-delete.69ce3c45.svg";